import {
  loginFailure,
  loginStart,
  loginSuccess,
  registerStart,
  registerSuccess,
  registerFailure,
  logoutStart,
  logoutSuccess,
  logoutFailure,
  getUserStart,
  getUserSuccess,
  getUserFailure,
  deleteUserStart,
  deleteUserSuccess,
  deleteUserFailure,
} from "./userRedux"
import { serverAPI } from "../services/apiParams.js"
import Cookies from "universal-cookie"
import {
  getProductStart,
  getProductSuccess,
  getProductFailure,
  addProductStart,
  addProductSuccess,
  addProductFailure,
  deleteProductStart,
  deleteProductSuccess,
  deleteProductFailure,
} from "./productsRedux"
import {
  getCategoryStart,
  getCategorySuccess,
  getCategoryFailure,
  deleteCategoryStart,
  deleteCategorySuccess,
  deleteCategoryFailure,
  addCategoryStart,
  addCategorySuccess,
  addCategoryFailure,
} from "./categoryRedux"
import { getOrderStart, getOrderSuccess, getOrderFailure } from "./orderRedux"

export const login = async (dispatch, user, setFormErrorMsg) => {
  dispatch(loginStart())
  try {
    const res = await serverAPI.post("api/login", user)
    dispatch(loginSuccess(res.data))
    const cookies = new Cookies()
    cookies.set("auth_token", res.data.jwt)
    setFormErrorMsg(undefined)
  } catch (error) {
    setFormErrorMsg(error.response.data.error)
    dispatch(loginFailure())
  }
}
export const Register = async (
  dispatch,
  user,
  setFormErrorMsg,
  handleClick
) => {
  dispatch(registerStart())
  try {
    await serverAPI.post("api/register", { ...user, is_admin: 1 })
    handleClick()
    dispatch(registerSuccess())
    setFormErrorMsg(undefined)
  } catch (error) {
    setFormErrorMsg(error.response.data.errors)
    dispatch(registerFailure())
  }
}

export const logout = async (dispatch) => {
  dispatch(logoutStart())
  try {
    await serverAPI.post("api/logout")
    dispatch(logoutSuccess())
  } catch (error) {
    dispatch(logoutFailure())
  }
}
export const getUsers = async (dispatch) => {
  dispatch(getUserStart())
  try {
    const res = await serverAPI.get("api/users")
    dispatch(getUserSuccess(res.data.users))
  } catch (error) {
    dispatch(getUserFailure())
  }
}

export const deleteUser = async (dispatch, user_id) => {
  dispatch(deleteUserStart())

  try {
    const res = await serverAPI.delete(`api/users/${user_id}`)
    res && dispatch(deleteUserSuccess(user_id))
  } catch (error) {
    dispatch(deleteUserFailure())
  }
}

//products
export const getProducts = async (dispatch) => {
  dispatch(getProductStart())
  try {
    const res = await serverAPI.get("api/products")
    dispatch(getProductSuccess(res.data.products))
  } catch (error) {
    dispatch(getProductFailure())
  }
}

export const deleteProduct = async (dispatch, product_id) => {
  dispatch(deleteProductStart())

  try {
    const res = await serverAPI.delete(`api/products/${product_id}`)
    res && dispatch(deleteProductSuccess(product_id))
  } catch (error) {
    dispatch(deleteProductFailure())
  }
}
export const addProduct = async (
  dispatch,
  productForm,
  handleClick,
  setFormErrorMsg
) => {
  dispatch(addProductStart())
  try {
    const res = await serverAPI.post(`api/products`, productForm)
    handleClick()
    res && dispatch(addProductSuccess(res.data.product))
    setFormErrorMsg(undefined)
  } catch (error) {
    setFormErrorMsg(error.response.data.errors)
    dispatch(addProductFailure())
  }
}
//categories
export const getCategories = async (dispatch) => {
  dispatch(getCategoryStart())
  try {
    const res = await serverAPI.get("api/categories")
    dispatch(getCategorySuccess(res.data.categories))
  } catch (error) {
    dispatch(getCategoryFailure())
  }
}

export const deleteCategory = async (dispatch, category_id) => {
  dispatch(deleteCategoryStart())

  try {
    const res = await serverAPI.delete(`api/categories/${category_id}`)
    res && dispatch(deleteCategorySuccess(category_id))
  } catch (error) {
    dispatch(deleteCategoryFailure())
  }
}
export const addCategory = async (
  dispatch,
  categoryForm,
  handleClick,
  setFormErrorMsg
) => {
  dispatch(addCategoryStart())

  try {
    const res = await serverAPI.post(`api/categories`, categoryForm)
    console.log("success", res)
    handleClick()
    res && dispatch(addCategorySuccess(res.data.category))
    setFormErrorMsg(undefined)
  } catch (error) {
    setFormErrorMsg(error.response.data?.errors)
    dispatch(addCategoryFailure())
  }
}
//orders
export const getOrders = async (dispatch) => {
  dispatch(getOrderStart())
  try {
    const res = await serverAPI.get("api/orders")
    dispatch(getOrderSuccess(res.data.orders))
  } catch (error) {
    dispatch(getOrderFailure())
  }
}
